class BaseSocialClient {
  userAccessToken?: string;

  setUserAccessToken(token?: string) {
    this.userAccessToken = token;
  }
}

export default BaseSocialClient;
